<template>
    <div>
        <h3 class="grey-color mb-3 main_text font-weight-bold">Акты сверки</h3>

        <b-table :busy="loading" :fields="fields" :items="items" :per-page="pagination.per_page" class="table-atmo" empty-text="История пуста" show-empty responsive>
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1"></b-spinner>
                    <strong>Загрузка данных...</strong>
                </div>
            </template>
            <template #cell(start_balance)="row">
                {{ $formatPrice(row.item.start_balance) }}
            </template>
            <template #cell(replenishments)="row">
                {{ $formatPrice(row.item.replenishments) }}
            </template>
            <template #cell(commission)="row">
                {{ $formatPrice(row.item.commission) }}
            </template>
            <template #cell(end_balance)="row">
                {{ $formatPrice(row.item.end_balance) }}
            </template>
            <template #cell(actions)="row">
                <action-button-small icon="download" @click="downloadReport(row.item.id)"></action-button-small>
            </template>
        </b-table>
        <b-pagination v-if="pagination.total" v-model="pagination.current_page" :per-page="pagination.per_page" :total-rows="pagination.total" align="center" class="mt-4 mb-0 mx-auto" @input="applyFilters" />
    </div>
</template>

<script>
export default {
    name: 'cabinet-accounting-reconciliation-reports',
    data() {
        return {
            loading: true,
            pagination: {},
            showFilterModal: false,
            items: [],
            fields: [
                { key: 'period', label: 'Период' },
                { key: 'start_balance', label: 'На начало', thClass: 'text-right', tdClass: 'text-right' },
                { key: 'replenishments', label: 'Зачислено', thClass: 'text-right', tdClass: 'text-right' },
                { key: 'commission', label: 'Комиссия', thClass: 'text-right', tdClass: 'text-right' },
                { key: 'end_balance', label: 'Остаток', thClass: 'text-right', tdClass: 'text-right' },
                { key: 'actions', label: '', thClass: 'text-right', tdClass: 'text-right' }
            ],
            disabled: false,
            isDownloading: false
        };
    },
    async created() {
        await this.fillData();
        this.$scrollToTop();
    },
    methods: {
        applyFilters() {
            this.loading = true;
            this.fillData();
        },
        async fillData() {
            this.loading = true;
            const response = await this.$api.personal.accounting.getReconciliationReports({ page: this.pagination.current_page || 1 });
            this.items = response.data;
            this.pagination = response.meta;
            this.loading = false;
        },
        downloadReport(reportId) {
            this.isDownloading = true;
            this.$api.personal.accounting
                .downloadReconciliationReportPDF(reportId)
                .finally(() => (this.isDownloading = false));
        }
    }
};
</script>

<style scoped>
.calendar_icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 30px;
    user-select: none;
    pointer-events: none;
}

.purchase_part-header {
    border-radius: 4px 4px 0 0;
    background-color: var(--green-color);
    padding: 9px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.purchase_part-header_number {
    font-size: 12px;
    color: #fff;
    margin: 0;
    font-weight: 600;
}

.purchase_part-header_label {
    text-transform: uppercase;
    color: #fff;
    margin: 0;
    display: flex;
    font-size: 12px;
    font-weight: 400;
}

.table {
    border-collapse: collapse;
}

.table thead th {
    background: #e4e6e8;
    font-size: 14px;
    font-weight: 600;
    padding: 15px 12px;
    color: var(--grey-color);
}

.table tbody td {
    font-size: 14px;
    padding: 18px 12px;
    border-bottom: 1px solid #dee2e6;
    color: var(--grey-color);
}
</style>
